import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export function AccountsLoadingState({ label }: { label: string }) {
    return (
        <Box role="status" aria-live="polite" aria-busy="true" sx={{ width: "100%" }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 750, mb: 1.25 }}>
                {label}
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
                {["ARS", "USD"].map((currency) => (
                    <Box key={currency}>
                        <Skeleton width={44} height={26} sx={{ mb: 1 }} />
                        <Paper
                            elevation={0}
                            sx={{
                                overflow: "hidden",
                                borderRadius: 3,
                                bgcolor: "background.paper",
                                border: (theme) => `1px solid ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.16 : 0.12)}`,
                            }}
                        >
                            {[0, 1, 2].map((row) => (
                                <Box
                                    key={row}
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "42px minmax(0, 1fr)",
                                        gap: 1.15,
                                        alignItems: "center",
                                        p: 1.25,
                                        borderBottom: row < 2 ? (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}` : 0,
                                    }}
                                >
                                    <Skeleton variant="circular" width={42} height={42} />
                                    <Box>
                                        <Skeleton width="58%" height={22} />
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 1, mt: 0.35 }}>
                                            <Skeleton width="62%" height={18} />
                                            <Skeleton width={86} height={18} />
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Paper>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export function AccountsRefreshingState({ label }: { label: string }) {
    return (
        <Typography
            role="status"
            aria-live="polite"
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: 750 }}
        >
            {label}
        </Typography>
    );
}
